import React, { FC } from "react";
import { Metric, metricLabel } from "../types";

const MetricTitle: FC<{ metric: Metric }> = ({ metric }) =>
  metric !== "list" ? (
    <div className="my-[1.5vw] flex items-center justify-center text-[3vw] font-extrabold text-lighterGray">
      {metricLabel[metric]}
    </div>
  ) : null;

export default MetricTitle;
